<template lang="pug">
.py-2.sticky-header
  .columns.align-center
    .column.col-auto
      i.text-error.fa-4x.fa-fw(v-if='icon', :class='icon')
    .column
      .h3 {{ title }}
      span(v-if='subtitle') {{ subtitle }}
    .column.col-auto
      slot(name='actions')
  .divider
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
}
</script>

<style lang="stylus" scoped>
.sticky-header
  position sticky
  top 0
  background-color #fff
  z-index 9
</style>
